import React, { useEffect, useRef, useState } from "react";
import {
  Col,
  Container,
  Form,
  InputGroup,
  Overlay,
  Row,
  Tooltip,
} from "react-bootstrap";
import degrees360Icon from "../../assets/images/360-degrees.svg";
import Skeleton from "react-loading-skeleton";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import CategoryListTab from "../../Modals/CategoryListTab";
import DeleteModal from "../../Modals/DeleteModal";
import RejectDetailModal from "../../Modals/RejectDetailModal";
import annualsummary from "../../assets/images/My_machine.svg";
import crossarrow from "../../assets/images/crossarrow.svg";
import deleteIcon from "../../assets/images/deleteaction.svg";
import toprightimg from "../../assets/images/marketplace-top-right.png";
import notesIcon from "../../assets/images/notes.svg";
import searchicon from "../../assets/images/searchicon.svg";
import profileicon from "../../assets/images/profileicon.svg";
import stars from "../../assets/images/stars.svg";
import useDebounce from "../../hooks/useDebounce";
import { commonservices, CountCharacter } from "../../services/CommonServices";
import { CategoryGetList } from "../../services/ReduxTookit/Slice/CategoryRedux";
import { GetListBySubscriberId } from "../../services/ReduxTookit/Slice/MachineRedux";
import Loader, { LoaderType } from "../common-component/Loader";
import Nodata from "../common-component/Nodata";
import { API_URL } from "../../services/APIRoute";
import { renderRatingStars } from "../Marketplace";

const MyMachine = () => {
  let Userdata = useSelector((state) => state?.userinfo?.UserInfo);

  let navigate = useNavigate();
  const [CategoryLoader, setCategoryLoader] = useState(false);
  const [DeleteMachineModalShow, setDeleteMachineModalShow] = useState(false);
  const [RejectDetailModalShow, setRejectDetailModalShow] = useState(false);
  const [RejectDetailModaldata, setRejectDetailModaldata] = useState();
  const [ProjectSearchTerm, setProjectSearchTerm] = useState("");
  const [DeletePayload, setDeletePayload] = useState({
    id: "",
  });
  const [MyMachineCounts, setMyMachineCounts] = useState({
    Total_Machines: "",
    Pending: "",
    In_Process: "",
    Rejected: "",
    Approved: "",
  });
  const [MachineLoader, setMachineLoader] = useState(false);
  const [CategoryList, setCategoryList] = useState([]);
  const [MachineList, setMachineList] = useState([]);
  const [page, setPage] = useState(1); // for number of page in data
  const [loading, setLoading] = useState(false);
  const loadingRef = useRef(false);
  const [totalRecord, setTotalRecord] = useState(null);
  const [FilteredMachineList, setFilteredMachineList] = useState([]);
  const [showOthersTab, setShowOthersTab] = useState(false);
  const othersTabRef = useRef();
  const machineStatusRef = useRef();
  const [selectedStatus, setSelectedStatus] = useState("");
  const [isApiCalled, setIsApiCalled] = useState(false);
  const [categoryApiLoader, setCategoryApiLoader] = useState(false);
  const [filter, setFilter] = useState({
    page: 1,
    search: "",
    categoryId: "",
    status: "",
  });
  const isApiCalledRef = useRef(false);
  const debouncingValue = useDebounce(ProjectSearchTerm, 500);
  const dispatch = useDispatch();

  const handleOverlay = (e) => {
    let element = document.getElementById(e?.currentTarget?.id);
    if (element) {
      if (element.classList.contains("overlay-isopen")) {
        element.classList.remove("overlay-isopen");
      } else {
        element.classList.add("overlay-isopen");
      }
    }
  };

  const handleshowMenu = (e) => {
    if (document.getElementById("body").classList.contains("popup-is-open")) {
      document.getElementById("body").classList.remove("popup-is-open");
      handleOverlay(e);
    } else {
      document.getElementById("body").classList.add("popup-is-open");
    }
    setShowOthersTab(!showOthersTab);
  };

  async function getCategoryList() {
    setCategoryLoader(true);
    let body = {
      categoryname: "",
      subscriberid: Userdata?.subscriberid,
    };
    // let resData = await apiCall(
    //   {
    //     method: "POST",
    //     url: API_URL.BASEURL + API_URL.CATEGORY.GET_USER_CATEGORY_LIST,
    //     body: body,
    //   },
    //   true
    // );
    // let response = apiResponse(false, resData, setCategoryLoader);
    const response = await dispatch(CategoryGetList(body));
    if (response?.payload?.isValidate) {
      setCategoryLoader(false);

      let filterData = response?.payload?.data?.data?.filter(
        (x) => x?.refcategoryid === 0,
      );
      let arr = [{ categoryid: "", categoryname: "All" }, ...filterData];
      setCategoryList(arr);
    }
    if (!response?.payload?.isValidate) {
      setCategoryLoader(false);

      setCategoryList([]);
    }
  }

  async function getMachineList(machineName) {
    if (filter?.page === 1) {
      setMachineLoader(true);
      setCategoryApiLoader(true);
    } else {
      setLoading(true);
      loadingRef.current = true;
    }

    let body = {
      machinename: filter?.search ? filter?.search : "",
      categoryids: filter?.categoryId ? filter?.categoryId : "",
      status: filter?.status ? filter?.status : "",
      pagenumber: filter?.page,
      pagesize: process.env.REACT_APP_MACHINE_WIDGET_PAGE_SIZE,
    };

    let response = await dispatch(GetListBySubscriberId(body));
    if (response?.payload?.isValidate) {
      // setMachineList(response?.payload?.data?.data?.dataList1);
      setIsApiCalled(true);
      if (filter?.page == 1) {
        setMachineList(response?.payload?.data?.data?.dataList1);
      } else {
        setMachineList((prevData) => [
          ...prevData,
          ...response?.payload?.data?.data?.dataList1,
        ]);
      }
      setTotalRecord(response?.payload?.data?.recordcount);
      setMyMachineCounts({
        Total_Machines:
          response?.payload?.data?.data?.dataList5?.[0]?.totalmachines,
        Pending: response?.payload?.data?.data?.dataList5?.[0]?.totalpending,
        In_Process:
          response?.payload?.data?.data?.dataList5?.[0]?.totalinprocess,
        Rejected: response?.payload?.data?.data?.dataList5?.[0]?.totalrejected,
        Approved: response?.payload?.data?.data?.dataList5?.[0]?.totalapproved,
      });
      setMachineLoader(false);
      setCategoryApiLoader(false);
      setLoading(false);
      loadingRef.current = false;
    }
    if (!response?.payload?.isValidate) {
      setMachineLoader(false);
      setCategoryApiLoader(false);
      setIsApiCalled(true);
      setMachineList([]);
      setFilteredMachineList([]);
      setMyMachineCounts({
        Total_Machines: "",
        Pending: "",
        In_Process: "",
        Rejected: "",
        Approved: "",
      });
      setLoading(false);
      loadingRef.current = false;
    }
  }
  useEffect(() => {
    getCategoryList();
  }, []);

  // useEffect(() => {
  //   getMachineList();
  // }, [page, CategoryID]);

  useEffect(() => {
    if (isApiCalledRef.current) {
      let updatedFilter = { ...filter };
      updatedFilter.page = 1;
      updatedFilter.search = debouncingValue;
      setFilter(updatedFilter);
    }
  }, [debouncingValue]);

  useEffect(() => {
    isApiCalledRef.current = true;
    getMachineList();
  }, [filter]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.innerHeight + window.scrollY;
      const bottomPosition = document.body.scrollHeight - 300;
      if (
        scrollPosition >= bottomPosition &&
        !loading &&
        !loadingRef.current &&
        MachineList?.length < totalRecord
      ) {
        loadingRef.current = true;
        let updatedFilter = { ...filter };
        updatedFilter.page = updatedFilter.page + 1;
        setFilter(updatedFilter);
        // setPage((prevPage) => prevPage + 1);
      }
      //  else {
      //   loadingRef.current = false;
      //   setLoading(false);
      // }
    };
    const debouncedScroll = debounce(handleScroll, 200);
    window.addEventListener("scroll", debouncedScroll);
    return () => {
      window.removeEventListener("scroll", debouncedScroll);
    };
  });

  // useEffect(() => {
  //   const delayDebounce = setTimeout(() => {
  //     if (ProjectSearchTerm) {
  //       setMachineList([]);
  //       getMachineList(ProjectSearchTerm);
  //     }
  //   }, 500);
  //   return () => {
  //     clearTimeout(delayDebounce);
  //   };
  // }, [ProjectSearchTerm]);

  function debounce(func, delay) {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  }

  const [activeTab, setActiveTab] = useState(0);
  const [showSearch, setShowSearch] = useState(false);

  const handleshowSearch = () => {
    setShowSearch(!showSearch);
  };

  const handleCardStatusClick = (status) => {
    if (filter?.status !== status) {
      // setMachineList([]);
      // setPage(1);
      // if (status === "Total Machines") {
      //   machineStatusRef.current = "";
      //   getMachineList();
      // } else {
      //   machineStatusRef.current = status;
      //   getMachineList();
      // }

      let updatedFilter = { ...filter };
      if (status === "Total Machines") {
        updatedFilter.status = "";
      } else {
        updatedFilter.status = status;
      }
      updatedFilter.page = 1;
      setFilter(updatedFilter);
    }
  };

  const handleOthersTabModal = (index, categoryId) => {
    if (filter?.categoryId === categoryId) return;
    // setProjectSearchTerm("");
    setMachineLoader(true);
    // setMachineList([]);
    setActiveTab(index);
    // setCategoryID(categoryId);

    let updatedFilter = { ...filter };
    updatedFilter.page = 1;
    updatedFilter.categoryId = categoryId;
    setFilter(updatedFilter);
  };
  const fnMachineDetail = (machine_id, item) => {
    const rawId =
      machine_id !== undefined && machine_id !== null && machine_id !== ""
        ? machine_id
        : item?.machineid ??
          item?.id ??
          item?.machineId ??
          item?.MachineId ??
          item?.refmachineid ??
          item?.machinename;

    if (rawId === undefined || rawId === null || rawId === "") return;

    try {
      const encrypted = commonservices.bodyEncryption(String(rawId));
      navigate(
        `/marketplace/marketplace-detail/${encrypted}/my machine`,
      );
    } catch (e) {
      console.error("fnMachineDetail navigation error", e);
      navigate(
        `/marketplace/marketplace-detail/${rawId}/my machine`,
      );
    }
  };

  const fnMachine360 = (machine_id, item) => {
    const rawRefMachineId =
      item?.refmachineid ??
      item?.refMachineId;

    const numRefId = Number(rawRefMachineId);

    const mId =
      machine_id !== undefined && machine_id !== null && machine_id !== ""
        ? machine_id
        : item?.machineid ??
          item?.id ??
          item?.machineId ??
          item?.MachineId ??
          item?.machinename;

    // If refmachineid is more than 0 then pass refmachineid, otherwise if refmachineid is 0 or lower than 0 then pass machineid
    const rawId = !isNaN(numRefId) && numRefId > 0 ? numRefId : mId;

    if (rawId === undefined || rawId === null || rawId === "") return;

    try {
      const encrypted = commonservices.bodyEncryption(String(rawId));
      navigate(
        `/marketplace/machine-360/${encrypted}/my machine`,
        { state: { machineData: item } }
      );
    } catch (e) {
      console.error("fnMachine360 navigation error", e);
      navigate(
        `/marketplace/machine-360/${rawId}/my machine`,
        { state: { machineData: item } }
      );
    }
  };

  return (
    <div className="dashboard-main market-place-page-main mymachine-main-page">
      <div className="all-page-top main-page-dash">
        <Container>
          <div className="top-section-all">
            <div className="top-section-left">
              <div className="d-flex align-items-center gap-3 mb16">
                <h1 className="mb-0">My Machine</h1>
                <Link to="/marketplace/addMachine" className="green-btn">
                  Upload My Machine
                </Link>
              </div>
              <div
                className={`my-machine-top-boxes-wrapper ${MachineLoader ? "disableClickEvent" : ""
                  }`}
              >
                {MachineLoader && !isApiCalled ? (
                  <Loader type={LoaderType.NumberCount} count={5} />
                ) : (
                  <>
                    <div
                      className={`cursor-pointer my-machine-top-box-single total-machines ${selectedStatus === "" ? "" : ""
                        }`}
                      onClick={(e) => {
                        handleCardStatusClick("");
                        setSelectedStatus("");
                      }}
                    >
                      <h4>
                        {MyMachineCounts?.Total_Machines
                          ? MyMachineCounts?.Total_Machines
                          : 0}
                      </h4>
                      <p>Total Machines</p>
                    </div>
                    <div
                      onClick={(e) => {
                        handleCardStatusClick("Pending");
                        setSelectedStatus("Pending");
                      }}
                      className={`my-machine-top-box-single pending-machines cursor-pointer ${selectedStatus === "Pending"
                          ? "active-status-border pending-machines"
                          : ""
                        }`}
                    >
                      <h4>
                        {MyMachineCounts?.Pending
                          ? MyMachineCounts?.Pending
                          : 0}
                      </h4>
                      <p>Pending</p>
                    </div>
                    <div
                      onClick={(e) => {
                        handleCardStatusClick("In Process");
                        setSelectedStatus("In Process");
                      }}
                      className={`my-machine-top-box-single in-process-machines cursor-pointer ${selectedStatus === "In Process"
                          ? "active-status-border in-process-machines"
                          : ""
                        }`}
                    >
                      <h4>
                        {MyMachineCounts?.In_Process
                          ? MyMachineCounts?.In_Process
                          : 0}
                      </h4>
                      <p>In Process</p>
                    </div>
                    <div
                      onClick={(e) => {
                        handleCardStatusClick("Rejected");
                        setSelectedStatus("Rejected");
                      }}
                      className={`cursor-pointer my-machine-top-box-single rejected-machines ${selectedStatus === "Rejected"
                          ? "active-status-border rejected-machines"
                          : ""
                        }`}
                    >
                      <h4>
                        {MyMachineCounts?.Rejected
                          ? MyMachineCounts?.Rejected
                          : 0}
                      </h4>
                      <p>Rejected</p>
                    </div>
                    <div
                      onClick={(e) => {
                        handleCardStatusClick("Publish");
                        setSelectedStatus("Publish");
                      }}
                      className={`cursor-pointer my-machine-top-box-single approved-machines ${selectedStatus === "Publish"
                          ? "active-status-border publish-machines"
                          : ""
                        }`}
                    >
                      <h4>
                        {MyMachineCounts?.Approved
                          ? MyMachineCounts?.Approved
                          : 0}
                      </h4>
                      <p>Approved</p>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="top-section-right">
              <img
                src={toprightimg}
                alt="top-right-img"
                className="top-section-right-img"
              />
            </div>
          </div>
        </Container>
      </div>
      <div className="main-page-content ">
        <Container>
          <div className="all-marketplace-wrapper">
            <Row>
              <Col xl={12}>
                <Row
                  className={` ${categoryApiLoader ? "disableClickEvent" : ""}`}
                >
                  <Col md={4}>
                    <div className="d-flex align-items-center gap-3">
                      <h2>My Machines</h2>
                      {/* {showSearch ? ( */}
                      <div className="header-search-input searchplaceholder">
                        <InputGroup>
                          <InputGroup.Text id="basic-addon1">
                            <img
                              src={searchicon}
                              alt="searchicon"
                              onClick={handleshowSearch}
                              className="cursor-pointer"
                            />
                          </InputGroup.Text>
                          <Form.Control
                            placeholder="Search Machines"
                            aria-label="Search"
                            aria-describedby="basic-addon1"
                            value={ProjectSearchTerm}
                            onChange={(e) => {
                              setProjectSearchTerm(e.target.value);
                              // setPage(1);

                              // if (e.target.value === "") {
                              //   setMachineList([]);
                              //   getMachineList(e.target.value);
                              // }
                            }}
                          />
                        </InputGroup>
                      </div>
                      {/* ) : (
                          <div className="serch-grp-only-search cursor-pointer">
                            <img
                              src={searchicon}
                              alt="searchicon"
                              onClick={handleshowSearch}
                            />
                          </div>
                        )} */}
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="custom-tabing">
                      {CategoryLoader ? (
                        <div className="single-tab">
                          <Skeleton height={15} width={200} />
                        </div>
                      ) : // Object.keys(CategoryList)?.length > 0 ? (
                        //   Object.keys(CategoryList)?.map((item, index) => (
                        //     <div
                        //       key={index}
                        //       className={
                        //         activeTab === index
                        //           ? "single-tab active"
                        //           : "single-tab"
                        //       }
                        //       onClick={() =>
                        //         handleTabClick(index, CategoryList[item])
                        //       }
                        //     >
                        //       <span>{item}</span>
                        //     </div>
                        //   ))
                        // ) : (
                        //   <div className="single-tab">
                        //     <span>No Data found.</span>
                        //   </div>
                        // )
                        CategoryList?.length > 0 ? (
                          <>
                            {CategoryList?.map((item, index) => {
                              if (index <= 4) {
                                return (
                                  <div
                                    key={item?.categoryid}
                                    className={
                                      activeTab === index
                                        ? "single-tab active"
                                        : "single-tab"
                                    }
                                    onClick={() => {
                                      if (
                                        filter?.categoryId === item?.categoryid
                                      ) {
                                        return;
                                      } else {
                                        setMachineLoader(true);
                                        // setMachineList([]);
                                        // setPage(1);
                                        // setProjectSearchTerm("");
                                        setActiveTab(index);
                                        // setCategoryID(item?.categoryid);

                                        let updatedFilter = { ...filter };
                                        updatedFilter.page = 1;
                                        updatedFilter.categoryId =
                                          item?.categoryid;
                                        setFilter(updatedFilter);
                                      }
                                    }}
                                  >
                                    <span>{item.categoryname}</span>
                                  </div>
                                );
                              }
                            })}
                            {CategoryList?.length > 5 && (
                              <div
                                className={
                                  activeTab > 4
                                    ? "single-tab active"
                                    : "single-tab"
                                }
                                onClick={(e) => {
                                  e.preventDefault();
                                  setShowOthersTab(!showOthersTab);
                                  handleshowMenu();
                                }}
                                ref={othersTabRef}
                              >
                                <span>Others</span>
                              </div>
                            )}
                          </>
                        ) : (
                          <div className="single-tab">
                            <span>No Data found.</span>
                          </div>
                        )}
                    </div>
                  </Col>
                  <Col md={4}></Col>
                  <Col className="mt-3" xl={12}>
                    {MachineLoader ? (
                      <>
                        <Loader type={LoaderType.NewCardWidgets} count={6} />
                      </>
                    ) : (
                      <>
                        {!MachineLoader && MachineList?.length > 0 ? (
                          <>
                            <div className="market-place-main-stickyaction">
                              <div className="all-market-place-main">
                                {MachineList?.map((item_m, index_m) => (
                                  <div
                                    key={index_m}
                                    className="single-market-place-main new-single-market-place-main cursor-pointer"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      fnMachineDetail(item_m?.machineid, item_m);
                                    }}
                                  >
                                    <button
                                      type="button"
                                      className="machine-360-action-btn"
                                      aria-label="360 View"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        const refId = Number(item_m?.refmachineid ?? item_m?.refMachineId);
                                        const targetId =
                                          !isNaN(refId) && refId > 0
                                            ? refId
                                            : item_m?.machineid;
                                        fnMachine360(targetId, item_m);
                                      }}
                                    >
                                      <img src={degrees360Icon} alt="360 View" className="machine-360-btn-icon" />
                                    </button>
                                    <div>
                                      <div
                                        className={`single-market-place-img ${commonservices.MachineStatus(
                                          item_m?.machinestatus,
                                        )}`}
                                      >
                                        <img
                                          src={
                                            item_m?.machinelogo !== "" &&
                                              item_m?.machinelogo !== null
                                              ? item_m?.machinelogo
                                              : annualsummary
                                          }
                                          alt="Machine Logo"
                                          onError={({ currentTarget }) => {
                                            currentTarget.onerror = null;
                                            currentTarget.src = annualsummary;
                                          }}
                                        />
                                      </div>
                                      {item_m?.machinestatus === "Rejected" && (
                                        <h3 className="version-name mt-2">
                                          {item_m?.versionnumber}
                                        </h3>
                                      )}
                                    </div>
                                    <div className="machine-card-right-content">
                                      <h4
                                        className="mt-0"
                                        title={item_m?.machinename}
                                      >
                                        {/* {commonservices.truncateText(

                                          item_m?.machinename,
                                          CountCharacter.MachineName
                                        )} */}
                                        {item_m?.machinename}
                                      </h4>
                                      <div className="rating-user-box">
                                        <span className="blue-badge">
                                          {item_m?.ratingcount || 0} user
                                        </span>
                                        {item_m?.avgrating > 0 ? (
                                          <div className="market-place-content-ratings">
                                            {renderRatingStars(
                                              item_m?.avgrating,
                                            )}
                                            <span>
                                              {item_m?.avgrating?.toFixed(1)}
                                            </span>
                                          </div>
                                        ) : (
                                          <div className="market-place-content-ratings">
                                            {renderRatingStars(0)}
                                            <span>{0}</span>
                                          </div>
                                        )}
                                        {item_m?.machinestatus ===
                                          "Rejected" && (
                                            <img
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                setRejectDetailModalShow(true);
                                                setRejectDetailModaldata(item_m);
                                              }}
                                              className="reject-icon ps-1"
                                              src={notesIcon}
                                              alt="notesIcon"
                                            />
                                          )}
                                        {item_m?.status === "Pending" && (
                                          <img
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setDeleteMachineModalShow(true);
                                              setDeletePayload({
                                                ...DeletePayload,
                                                id: item_m?.machineid,
                                              });
                                            }}
                                            className="reject-icon ps-1"
                                            src={deleteIcon}
                                            alt="deleteIcon"
                                          />
                                        )}
                                      </div>
                                      <p
                                        className="description-text-limited"
                                        title={commonservices.truncateText(
                                          commonservices.stripHTML(
                                            item_m?.shortdescription,
                                          ),
                                          CountCharacter?.MachineShortDetail,
                                        )}
                                      >
                                        {item_m?.shortdescription
                                          ? commonservices.stripHTML(
                                            item_m.shortdescription,
                                          )
                                          : ""}
                                      </p>
                                      <span className="developer-box">
                                        <img
                                          src={profileicon}
                                          alt="profileicon"
                                        />
                                        <Link
                                          to="/marketplace/developer"
                                          state={{
                                            subscriberId: item_m?.subscriberid,
                                          }}
                                          onClick={(e) => e.stopPropagation()}
                                        >
                                          {item_m?.subscribername}
                                        </Link>
                                      </span>
                                    </div>
                                  </div>
                                ))}
                                {loading ? (
                                  <>
                                    <Loader
                                      type={LoaderType.MachineCardLoader}
                                      count={6}
                                    />
                                  </>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </>
                        ) : (
                          <Nodata />
                        )}
                      </>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
      {RejectDetailModalShow && (
        <RejectDetailModal
          data={RejectDetailModaldata}
          show={RejectDetailModalShow}
          onHide={() => setRejectDetailModalShow(false)}
        />
      )}
      {showOthersTab && (
        <Overlay
          target={othersTabRef.current}
          show={showOthersTab}
          placement="bottom-end"
        >
          {(props) => (
            <Tooltip id="overlay-example" {...props}>
              <CategoryListTab
                handleshowPopup={handleshowMenu}
                categoryList={CategoryList}
                handleCategoryClick={handleOthersTabModal}
                selectedCategory={activeTab}
              />
            </Tooltip>
          )}
        </Overlay>
      )}
      {DeleteMachineModalShow && (
        <DeleteModal
          payload={DeletePayload}
          method="POST"
          // url={API_URL.BASEURL.MACHINE.MACHINE_DELETE}
          url={API_URL?.MACHINE?.MACHINE_DELETE}
          show={DeleteMachineModalShow}
          bindlist={getMachineList}
          onHide={(e) => setDeleteMachineModalShow(false)}
        />
      )}
    </div>
  );
};

export default MyMachine;
